import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { CustomerShell } from "@/components/CustomerShell";
import { toast } from "sonner";
import { ChevronLeft, Loader2, Star, UserCheck, Users, Trash2 } from "lucide-react";

export default function MyTeam() {
    const [pros, setPros] = useState(null);
    const nav = useNavigate();

    const load = () => api.get("/preferred-pros").then((r) => setPros(r.data)).catch(() => setPros([]));
    useEffect(() => { load(); }, []);

    const remove = async (id) => {
        try { await api.delete(`/preferred-pros/${id}`); toast.success("Removed from your team"); load(); }
        catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    };

    return (
        <CustomerShell>
            <div className="sticky top-0 z-20 flex items-center gap-3 bg-navy px-5 pb-4 pt-5 text-white">
                <button onClick={() => nav(-1)} className="rounded-full bg-white/10 p-2 transition-colors hover:bg-white/20"><ChevronLeft size={20} /></button>
                <h1 className="font-heading text-lg font-bold">My HOMIIE Team</h1>
            </div>
            <div className="px-5 py-5">
                {pros === null && <div className="flex justify-center py-12"><Loader2 className="h-7 w-7 animate-spin text-orange" /></div>}
                {pros && pros.length === 0 && (
                    <div className="mt-8 flex flex-col items-center text-center">
                        <div className="rounded-full bg-navy/5 p-5"><Users size={40} className="text-navy/30" /></div>
                        <h3 className="mt-4 font-heading text-lg font-bold text-navy">No preferred pros yet</h3>
                        <p className="mt-1 text-sm text-navy/50">After a great service, save the professional to book them again.</p>
                    </div>
                )}
                <div className="space-y-3">
                    {pros?.map((p) => (
                        <div key={p.id} className="rounded-2xl border border-navy/10 bg-white p-4" data-testid={`team-pro-${p.pro_id}`}>
                            <div className="flex items-center gap-3">
                                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-navy text-lg font-bold text-orange">{p.name[0]}</div>
                                <div className="flex-1">
                                    <div className="flex items-center gap-1.5">
                                        <h3 className="font-heading font-bold text-navy">{p.name}</h3>
                                        {p.verification_status === "Verified" && <UserCheck size={15} className="text-emerald-500" />}
                                    </div>
                                    <p className="flex items-center gap-1 text-xs text-navy/50"><Star size={12} className="fill-orange text-orange" /> {p.rating || "New"} · {p.pro_id}</p>
                                </div>
                                <button data-testid={`remove-pro-${p.pro_id}`} onClick={() => remove(p.id)} className="rounded-full p-2 text-navy/40 transition-colors hover:text-red-500"><Trash2 size={17} /></button>
                            </div>
                            <button data-testid={`book-again-${p.pro_id}`} onClick={() => nav("/book")} className="mt-3 w-full rounded-full bg-orange py-2.5 text-sm font-bold text-white transition-transform active:scale-95">BOOK AGAIN</button>
                        </div>
                    ))}
                </div>
            </div>
        </CustomerShell>
    );
}
